.ma{min-width:14rem;}